import React from 'react';
import { CheckCircle, ArrowRight, Sparkles } from 'lucide-react';
import '../SignUpSuccessModal/SignUpSuccessModal.css';

interface SignUpSuccessModalProps {
  email: string;
  onContinue: () => void;
}

const SignUpSuccessModal: React.FC<SignUpSuccessModalProps> = ({ email, onContinue }) => {
  return (
    <div className="homecookt-signup-success-overlay">
      <div className="homecookt-signup-success-modal">
        {/* Animated Success Icon */}
        <div className="homecookt-success-icon-container">
          <div className="homecookt-success-icon-circle">
            <CheckCircle size={60} />
          </div>
          <div className="homecookt-success-sparkles">
            <Sparkles className="homecookt-sparkle homecookt-sparkle-1" size={16} />
            <Sparkles className="homecookt-sparkle homecookt-sparkle-2" size={14} />
            <Sparkles className="homecookt-sparkle homecookt-sparkle-3" size={18} />
            <Sparkles className="homecookt-sparkle homecookt-sparkle-4" size={12} />
          </div>
        </div>

        {/* Success Content */}
        <div className="homecookt-success-content">
          <h2 className="homecookt-success-title">Account Created!</h2>
          <p className="homecookt-success-subtitle">
            Welcome to HomeCookt! Your account has been successfully created and verified.
          </p>
          <div className="homecookt-success-email-box">
            <span className="homecookt-email-label">Registered Email:</span>
            <span className="homecookt-email-value">{email}</span>
          </div>
        </div>

        {/* Benefits Preview */}
        <div className="homecookt-success-benefits">
          <h3 className="homecookt-benefits-title">What's Next?</h3>
          <div className="homecookt-benefits-grid">
            <div className="homecookt-benefit-card">
              <span className="homecookt-benefit-emoji">🍽️</span>
              <span className="homecookt-benefit-text">Discover amazing meals</span>
            </div>
            <div className="homecookt-benefit-card">
              <span className="homecookt-benefit-emoji">👨‍🍳</span>
              <span className="homecookt-benefit-text">Share your recipes</span>
            </div>
            <div className="homecookt-benefit-card">
              <span className="homecookt-benefit-emoji">🚚</span>
              <span className="homecookt-benefit-text">Earn through delivery</span>
            </div>
          </div>
        </div>

        {/* Continue Button */}
        <button 
          onClick={onContinue}
          className="homecookt-success-continue-button"
        >
          <span>Continue to Login</span>
          <ArrowRight size={18} />
        </button>

        {/* Footer Message */}
        <div className="homecookt-success-footer">
          <p>🎉 You're all set! Log in to start your culinary journey.</p>
        </div>
      </div>
    </div>
  );
};

export default SignUpSuccessModal;